import { createSlice } from '@reduxjs/toolkit'

export const userRolePermissionSlice = createSlice({
  name: 'userRolePermission',
  initialState: {
    userRolePermission: null,
  },
  reducers: {
    getUserRolePermission: (state, action) => {
      state.userRolePermission = action.payload
    }
  },
})

// Action creators are generated for each case reducer function
export const { getUserRolePermission } = userRolePermissionSlice.actions

export default userRolePermissionSlice.reducer
